import { createSvgIconComponent } from "../utils";

export const IconX = createSvgIconComponent({
  path: "M17,15.6L15.6,17L12,13.4L8.4,17L7,15.6l3.6-3.6L7,8.4L8.4,7l3.6,3.6L15.6,7L17,8.4L13.4,12L17,15.6z",
  viewBox: "0 0 24 24",
});
